import PropTypes from 'prop-types';
import TreeItem from '../Components/TreeNavigator/TreeItem';

const TreeNavigatorSingleItemPropTypes = {
  classes: PropTypes.object.isRequired,
  treeItem: PropTypes.instanceOf(TreeItem).isRequired,
};

export default TreeNavigatorSingleItemPropTypes;
